// removed by extract-text-webpack-plugin
module.exports = {"root":"Triumphs--root--2Y","scoreBox":"Triumphs--scoreBox--2O","scoreTitle":"Triumphs--scoreTitle--RR","scoreScore":"Triumphs--scoreScore--32","crumb":"Triumphs--crumb--1K","crumbLink":"Triumphs--crumbLink--EW"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Triumphs/styles.styl
// module id = 889
// module chunks = 0